import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';

import { AuthenticationService } from 'src/app/core/services/auth.service';
import { SpinnerService } from '../../core/services/spinner.service';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakAuthorizationService } from 'src/app/auth/keycloak.authorization.service';

@Component({
    selector: 'app-layout-simple',
    templateUrl: './layout-simple.component.html',
    styleUrls: ['./layout-simple.component.css'],
    standalone: false
})
export class LayoutSimpleComponent implements OnDestroy, AfterViewInit {

    selectedLanguage:string = "sk";
    selectedLanguageLabel:string = "en";

    private _mobileQueryListener: () => void;
    mobileQuery: MediaQueryList;
    showSpinner: boolean = false;
    userName: string = "";
    isAdmin: boolean = false;

    private autoLogoutSubscription: Subscription = new Subscription;

    currentRoute: string = "";
    
    constructor(private changeDetectorRef: ChangeDetectorRef,
        private media: MediaMatcher,
        public spinnerService: SpinnerService,
        private translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute
    ) {

        this.mobileQuery = this.media.matchMedia('(max-width: 1000px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        // tslint:disable-next-line: deprecation
        this.mobileQuery.addListener(this._mobileQueryListener);

        this.router.events.subscribe(() => {
            this.currentRoute = this.router.url;
        });

        this.route.queryParamMap.subscribe(queryParams => {
            var language = queryParams.get('language');
            if(language === null){
                // this.selectedLanguage = 'en'
                this.selectedLanguageLabel = 'sk'
                // this.translate.use(this.selectedLanguageLabel)
                // window.localStorage.setItem('languagePreference', this.selectedLanguage)
                this.reloadPage();
            }
            else{
                var lang = language.toLowerCase();
                this.translate.use(lang)
                window.localStorage.setItem('languagePreference', lang)

                
                this.selectedLanguage = lang;
                this.selectedLanguageLabel = lang === 'sk' ? 'en' : 'sk'
            }

            // var language = queryParams.get('language');
            // if(language === null){
            //     language = 'en'
            // }
            // this.selectedLanguage = language;
            // this.selectedLanguageLabel = language === 'sk' ? 'en' : 'sk'
            // window.localStorage.setItem('languagePreference', language)
        });
    }
    
    ngOnDestroy(): void {
        // tslint:disable-next-line: deprecation
        this.mobileQuery.removeListener(this._mobileQueryListener);
        this.autoLogoutSubscription.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.changeDetectorRef.detectChanges();
    }

    reloadPage(){
        const url = new URL(window.location.href);
        url.searchParams.set('language', this.selectedLanguageLabel.toUpperCase());
        window.location.href = url.toString();
    }
}
